let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aOtuZ")).then(() => parcelRequire('9Qu19'));